var DashUser = /** @class */ (function () {
    function DashUser() {
    }
    return DashUser;
}());
export default DashUser;
var DashCustomUserNoteRequest = /** @class */ (function () {
    function DashCustomUserNoteRequest() {
    }
    return DashCustomUserNoteRequest;
}());
export { DashCustomUserNoteRequest };
export var UserNoteLogLevel;
(function (UserNoteLogLevel) {
    UserNoteLogLevel["Info"] = "Info";
    UserNoteLogLevel["Success"] = "Success";
    UserNoteLogLevel["Error"] = "Error";
})(UserNoteLogLevel || (UserNoteLogLevel = {}));
